import React, { useState, useEffect } from 'react'
import {
   Space, Button, Card, InputNumber, Avatar, Popconfirm, Menu, Dropdown, Modal, Progress,
   Typography, Tooltip, Row, Col, message, Badge, Image, Upload, Divider, Descriptions, Statistic
} from 'antd';
import axios from 'axios';
import { CloseCircleTwoTone, AlertTwoTone, PlusOutlined, RetweetOutlined, SoundOutlined, VideoCameraOutlined, PictureOutlined } from '@ant-design/icons';

import EssayItem from './question-items/Essay';
import MultipleAnswerItem from './question-items/MultipleAnswer';
import MultipleChoiceItem from './question-items/MultipleChoice';
import ShortAnswerItem from './question-items/ShortAnswer';
import MultipleChoiceImageItem from './question-items/MultipleChoiceImage';
import MultipleAnswerImageItem from './question-items/MultipleAnswerImage';
import MatchingType from './question-items/MatchingType';
import MatchingTypeImage from './question-items/MatchingTypeImage';
import { normalizeMatchingAnswer, normalizeMatchingAnswers } from './matchingAnswerGuard';
import TrueOrFalseItem from './question-items/TrueOrFalse';

import TextArea from 'antd/lib/input/TextArea';
import ReactPlayer from 'react-player';

// import Wysiwyg from '../wysiwyg/wysiwyg';
import Wysiwyg2 from '../wysiwyg/wysiwyg2';
// import { isMobile } from 'react-device-detect';
import WysiwygMathEditor from '../wysiwyg/WysiwygMathEditor';
import { stripQuillFormulaGuards } from '../wysiwyg/quillFormulaGuard';

import {
   Chart as ChartJS,
   CategoryScale,
   LinearScale,
   BarElement,
   Title as Title2,
   Tooltip as Tooltip2,
   Legend,
} from 'chart.js';
import { Bar } from "react-chartjs-2";
import ItemAnalysisAnswers from './ItemAnalysisAnswers';
import Utils from '../../misc/Utils';

const { Text, Title } = Typography;
const { Dragger } = Upload;
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function BraineeQuestionCard(props) {
   //-- Matching answers are letters only; values saved by older versions of the
   //   answer input may still carry stray characters such as "B." or ".G"
   //   (see matchingAnswerGuard.js).
   const isMatchingType = String(props.type ?? "").includes("matching_type");

   const [optionValues, setOptionValues] = useState(props.option_labels !== undefined && props.option_labels !== '' ? props.option_labels : []);

   //--correctAnswers (this will be used to hold data from create/edit/answer)
   const [correctAnswers, setCorrectAnswers] = useState(() => {
      const value = props.correct !== undefined && props.correct !== '' ? props.correct : [];

      return isMatchingType ? normalizeMatchingAnswers(value) : value;
   });
   const [points, setPoints] = useState(props.points !== undefined && props.points !== '' ? props.points : '1');
   const [question, setQuestion] = useState(props.question !== undefined && props.question !== '' ? props.question : '');
   const [editorContent, setEditorContent] = useState(props.question !== undefined && props.question !== '' ? props.question : '');
   const [imageURL, setImageURL] = useState(props.image_url !== undefined && props.image_url !== '' ? props.image_url : []);
   const [studentAnswers, setStudenttAnswers] = useState(() => {
      const value = props.answers !== undefined && props.answers !== '' ? props.answers : [];

      return isMatchingType ? normalizeMatchingAnswers(value) : value;
   });
   const [hasAnswers, setHasAnswers] = useState(props.has_answers !== undefined && props.has_answers !== '' ? props.has_answers : false);

   var subdomain = localStorage.getItem("lms-subdomain");

   // if (props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic')
   //    subdomain = "ccph";

   useEffect(() => {
      ChartJS.register(
         CategoryScale,
         LinearScale,
         BarElement,
         Title2,
         Tooltip2,
         Legend
      );
   }, []);

   const [questionImage, setQuestionImage] = useState(() => {
      if (props.question_image !== undefined) {
         if (props.question_image.length > 0) {
            if (props.question_image.includes('base64'))
               return props.question_image;
            else
               return `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${props.question_image.substring(props.question_image.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), props.question_image.length)}`;
         }
         else
            return '';
      }
      else
         return '';
   });

   const [questionAudio, setQuestionAudio] = useState(() => {
      if (props.question_audio !== undefined) {
         if (props.question_audio.length > 0) {
            return `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${props.question_audio.substring(props.question_audio.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), props.question_audio.length)}`;
         }
         else
            return '';
      }
      else
         return '';
   });

   const [questionVideo, setQuestionVideo] = useState(() => {
      if (props.question_video !== undefined) {
         if (props.question_video.length > 0) {
            return `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${props.question_video.substring(props.question_video.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), props.question_video.length)}`;
         }
         else
            return '';
      }
      else
         return '';
   });

   // const cardBackgroundColor = props.matched !== undefined ? (props.matched === true ? "#DFFFDC" : "#FFDCDC") : "#f3f7fd";
   const enable_consider = props.enable_consider !== undefined ? props.enable_consider : true;

   const [percentage, setPercentage] = React.useState(0);
   const [isUploading, setIsUploading] = React.useState(false);

   const [showStudentAnswers, setShowStudentAnswers] = useState(false);
   // const [studentAnswes, setStudentAnswers] = useState(null);

   // const [editorState, setEditorState] = useState(EditorState.createEmpty());

   // const subject = props.subject_name;
   // const cardbg = props.card_bg;

   const handleRequest = (method, value, idx) => {
      var ov = [...optionValues];
      var ca = [...correctAnswers];
      var img = [...imageURL];
      var pts = points;
      var qstn = question;
      // var qstn_img = questionImageURL;
      var qstn_img = questionImage !== '' ? questionImage.substring(questionImage.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), questionImage.length) : '';
      var qstn_aud = questionAudio !== '' ? questionAudio.substring(questionAudio.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), questionAudio.length) : '';
      var qstn_vid = questionVideo !== '' ? questionVideo.substring(questionVideo.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), questionVideo.length) : '';

      switch (method) {
         case "remove":
            if (!hasAnswers) {
               ov.splice(idx, 1);
               ca.splice(idx, 1);
               if (img.length > 0) img.splice(idx, 1);
            } else {
               message.info('Removing answer keys is not allowed.');
            }
            break;
         case "update":
            ov[idx] = value;
            // ca[idx] = '0';
            break;
         case "add":
            if (!hasAnswers) {
               if (ov.length <= alphabet.length - 1) {
                  ov.push(alphabet[ov.length]);
                  // ov.push('');
                  ca.push('0');
                  if (img.length > 0) img.push('');
               } else {
                  message.info('Maximum number of answer keys reached.')
               }
            } else {
               message.info('Adding more answer keys is not allowed.');
            }

            break;
         case "update-check":
            ca[idx] = value === true ? '1' : '0';
            break;
         case "update-check-radio":
            for (var i = 0; i < ca.length; i++) {
               if (i === idx)
                  ca[i] = '1';
               else
                  ca[i] = '0';
            };
            break;
         case "update-input":
            if (props.mode === "answer") {
               ca = value;
            } else {
               ca[idx] = value;
            }
            break;
         case "update-points":
            pts = value === null ? 1 : value;
            break;
         case "update-question":
            setEditorContent(value);
            qstn = value;
            break;
         case "update-image-url":
            img[idx] = value;
            break;
         case "add-correct":
            // if (!hasAnswers)
            //    ca.push(value)
            // else
            //    message.info('Adding more answer keys is not allowed.');

            ca.push(value)
            break;
         case "update-question-image":
            qstn_img = value;
            break;
         case "update-question-audio":
            qstn_aud = value;
            break;
         case "update-question-video":
            qstn_vid = value;
            break;
         case "add-mt":
            if (!hasAnswers) {
               if (ov.length <= alphabet.length - 1) {
                  ov.push(['', '']);
                  ca.push('');
                  if (img.length > 0) img.push(['', '']);
               } else {
                  message.info('Maximum number of answer keys reached.')
               }
            } else {
               message.info('Adding more answer keys is not allowed.');
            }

            break;
         case "update-input-multi":
            ca[idx] = value;
            break;
         case "update-col-a": //--Matching type
            ov[idx][0] = value;
            break;
         case "update-col-b": //--Matching type
            ov[idx][1] = value;
            break;
         case "update-image-col-a": //--Matching type image
            img[idx][0] = value;
            break;
         case "update-image-col-b": //--Matching type image
            img[idx][1] = value;
            break;
         default:
            break;
      }

      if (props.mode === "answer") {
         props.answerCallback(ca, props.id); //-- Update student answers
      } else {
         var data = {};

         if (img.length > 0) {
            data = {
               correct: ca,
               option_labels: ov,
               points: pts,
               question: qstn,
               image_url: img,
               question_image: qstn_img,
            }
         } else {
            data = {
               correct: ca,
               option_labels: ov,
               points: pts,
               question: qstn,
               question_image: qstn_img,
               question_audio: qstn_aud,
               question_video: qstn_vid,
            }
         }

         props.parentCallback("update", "", data, props.id); //-- Update parent state answer keys data
      }

      setOptionValues(ov);
      setCorrectAnswers(ca);
      setPoints(pts);
      setQuestion(qstn);

      if (qstn_img !== null && qstn_img.length > 0) setQuestionImage(`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${qstn_img}`);
      if (img.length > 0) setImageURL(img);
      if (qstn_aud !== null && qstn_aud.length > 0) setQuestionAudio(`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${qstn_aud}`);
      if (qstn_vid !== null && qstn_vid.length > 0) setQuestionVideo(`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${qstn_vid}`);
   }

   const handleCardRequest = (method, idx) => {
      props.parentCallback(method, "", "", idx);
   }

   const handleConsiderAnswer = (questionKeyId, answer_to_consider) => {
      props.considerAnswerCallback(questionKeyId, answer_to_consider);
   }

   const generateQuestionOptions = () => {
      if (props.type !== "long_answer") {
         if (props.type === "short_answer") {
            if (props.mode === "answer" || props.mode.includes("-view")) {
               return (
                  <ShortAnswerItem
                     key={props.id}
                     id={props.id}
                     correct={props.mode.includes("-view") ? props.answers : props.correct}
                     mode={props.mode}
                     parentCallback={handleRequest}
                     mobileVirtualKeyboard={props.mobileVirtualKeyboard}
                  />
               )
            } else {
               return correctAnswers.map((el, i) => (
                  <ShortAnswerItem
                     key={props.id + "_" + i}
                     id={i}
                     correct={correctAnswers[i]}
                     mode={props.mode}
                     parentCallback={handleRequest}
                  />
               ))
            }
         } else if (props.type === "true_or_false") {
            return optionValues.map((el, i) => (
               <TrueOrFalseItem
                  key={props.id + "_" + i}
                  cardid={i}
                  id={i}
                  value={el}
                  correct={props.mode.includes("-view") ? studentAnswers[i] : correctAnswers[i]}
                  mode={props.mode}
                  parentCallback={handleRequest}
               />
            ))
         } else if (props.type === "multiple_answer") {
            return optionValues.map((el, i) => (
               <MultipleAnswerItem
                  key={props.id + "_" + i}
                  id={i}
                  value={el}
                  correct={props.mode.includes("-view") ? studentAnswers[i] : correctAnswers[i]}
                  mode={props.mode}
                  parentCallback={handleRequest}
               />
            ))
         } else if (props.type === "multiple_answer_image") {
            return (<>
               <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  {optionValues.map((el, i) => (
                     <MultipleAnswerImageItem
                        key={props.id + "_" + i}
                        id={i}
                        value={el}
                        correct={props.mode.includes("-view") ? studentAnswers[i] : correctAnswers[i]}
                        mode={props.mode}
                        parentCallback={handleRequest}
                        image_url={props.image_url[i]}
                        assessment_type={props.assessment_type}
                     />
                  ))}
               </div>
            </>)
         } else if (props.type === "multiple_choice") {
            return optionValues.map((el, i) => (
               <MultipleChoiceItem
                  key={props.id + "_" + i}
                  cardid={props.id}
                  id={i}
                  value={el}
                  correct={props.mode.includes("-view") ? studentAnswers[i] : correctAnswers[i]}
                  mode={props.mode}
                  parentCallback={handleRequest}
               />
            ))
         } else if (props.type === "multiple_choice_image") {
            return (<>
               <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  {optionValues.map((el, i) => (
                     <MultipleChoiceImageItem
                        key={props.id + "_" + i}
                        cardid={props.id} id={i}
                        value={el}
                        correct={props.mode.includes("-view") ? studentAnswers[i] : correctAnswers[i]}
                        mode={props.mode}
                        parentCallback={handleRequest}
                        image_url={props.image_url[i]}
                        assessment_type={props.assessment_type}
                     />
                  ))}
               </div>
            </>)
         } else if (props.type === "matching_type") {
            return (
               <>
                  <Row width={'100%'} gutter={['12', '12']} style={{ display: 'flex', padding: '3px', alignItems: 'center', textAlign: 'center' }}>
                     <Col span={12} >Column A</Col>
                     <Col span={12} >Column B</Col>
                  </Row>
                  {
                     optionValues.map((el, i) => (
                        <MatchingType
                           key={props.id + "_" + i}
                           cardid={props.id}
                           id={i}
                           value={el}
                           correct={props.mode.includes("-view") ? studentAnswers[i] : correctAnswers[i]}
                           mode={props.mode}
                           parentCallback={handleRequest}
                           label={alphabet[i]}
                           matched={
                              props.mode.includes("-view")
                                 ? (() => {
                                    const student = normalizeMatchingAnswer(studentAnswers?.[i]);
                                    if (!student) return false;
                                    return student.toLowerCase() === normalizeMatchingAnswer(correctAnswers?.[i]).toLowerCase();
                                 })()
                                 : false
                           }
                        />
                     ))}
               </>
            )
         } else if (props.type === "matching_type_image") {
            return (
               <>
                  <Row width={'100%'} gutter={['12', '12']} style={{ display: 'flex', padding: '3px', alignItems: 'center', textAlign: 'center' }}>
                     <Col span={12} >Column A</Col>
                     <Col span={12} >Column B</Col>
                  </Row>
                  {
                     optionValues.map((el, i) => (
                        <MatchingTypeImage
                           key={props.id + "_" + i}
                           cardid={props.id}
                           id={i}
                           value={el}
                           correct={props.mode.includes("-view") ? studentAnswers[i] : correctAnswers[i]}
                           mode={props.mode}
                           parentCallback={handleRequest}
                           label={alphabet[i]}
                           image_url={props.image_url[i]}
                           matched={
                              props.mode.includes("-view")
                                 ? (() => {
                                    const student = normalizeMatchingAnswer(studentAnswers?.[i]);
                                    if (!student) return false;
                                    return student.toLowerCase() === normalizeMatchingAnswer(correctAnswers?.[i]).toLowerCase();
                                 })()
                                 : false
                           }
                           assessment_type={props.assessment_type}
                        />
                     ))
                  }
               </>
            )
         }
      } else {
         return <EssayItem
            key={props.id}
            id={props.id}
            mode={props.mode}
            value={props.mode.includes("view") && props.mode !== "preview" ? props.answers[0] : (props.mode === 'answer' ? props.correct[0] : '')}
            parentCallback={handleRequest}
            assessment_type={props.assessment_type}
            onTrustedUploadStart={props.onTrustedUploadStart}
            onTrustedUploadEnd={props.onTrustedUploadEnd}
            mobileVirtualKeyboard={props.mobileVirtualKeyboard}
         />
      }
   }

   function getCorrectAnswer(type, correct_answer_seq, option_labels) {
      var retVal = "";

      if (type !== "long_answer") {
         if (type === "short_answer")
            retVal = correct_answer_seq.join(' or ');
         else if (type.includes("multiple_answer")) {
            for (var i = 0; i < correct_answer_seq.length; i++) {
               if (correct_answer_seq[i] === "1") {
                  if (retVal !== "") retVal += " and ";
                  retVal += option_labels[i];
               }
            }
         } else if (type.includes('matching_type')) {
            retVal = correct_answer_seq.join(', ');
         } else {
            for (var i = 0; i < correct_answer_seq.length; i++) {
               if (correct_answer_seq[i] === "1")
                  retVal += option_labels[i];
            }
         }
      }

      return retVal === '' 
      ? <span><AlertTwoTone twoToneColor={'red'} /><Text style={{ color: 'red', fontStyle: 'italic' }}>Correct answer was not set.</Text></span> 
      : retVal;
   }

   const beforeImageUpload = (file) => {
      var isValid = ["image/jpeg", "image/png"].includes(file.type); //  === 'image/jpeg' || file.type === 'image/png';

      if (!isValid) {
         message.error('You can only upload JPG and PNG files!');
      }

      var isLt = file.size / 1024 / 1024 < 10;
      if (!isLt) {
         message.error('Image must smaller than 10MB!');
      }

      // handleChangeToBase64(file, 'update-question-image');
      if (isValid && isLt)
         handleUpload(file, 'update-question-image');
   }

   const beforeAudioUpload = (file) => {
      var isValid = file.type === 'audio/mpeg' || file.type === 'audio/wav';

      if (!isValid) {
         message.error('You can only upload MP3 and WAV files!');
      }

      var isLt = file.size / 1024 / 1024 < 4;
      if (!isLt) {
         message.error('Audio file must be smaller than 4MB!');
      }

      // handleChangeToBase64(file, 'update-question-audio');
      if (isValid && isLt)
         handleUpload(file, 'update-question-audio');
   }

   const beforeVideoUpload = (file) => {
      var isValid = file.type === 'video/mp4' || file.type === 'video/webm' || file.type === 'video/ogg' || file.type === 'video/x-ms-wmv';

      if (!isValid) {
         message.error('You can only upload MP4 and WEBM files!');
      }

      var isLt = file.size / 1024 / 1024 < 10;
      if (!isLt) {
         message.error('Video file must be smaller than 10MB!');
      }

      // handleChangeToBase64(file, 'update-question-video');
      if (isValid && isLt)
         handleUpload(file, 'update-question-video');
   }

   const upload_option = {
      onUploadProgress: (progressEvent) => {
         const { loaded, total } = progressEvent;
         let p = Math.floor((loaded * 100) / total)
         setPercentage(p)
         //console.log(`${percentage} %`)
      }
   }

   const handleUpload = async (file, command) => {
      setIsUploading(true);

      let uploadFile = file;

      //-- Compress image before upload
      if (command === 'update-question-image') {
         try {
            const compressedBlob = await Utils.advancedImageCompress(file);

            const ext = compressedBlob.type.split("/")[1] || "jpg";

            uploadFile = new File(
               [compressedBlob],
               file.name.replace(/\.[^/.]+$/, `${ext}`),
               {
                  type: compressedBlob.type,
               }
            );

            console.log(
               `Original: ${(file.size / 1024).toFixed(2)} KB`
            );

            console.log(
               `Compressed: ${(uploadFile.size / 1024).toFixed(2)} KB`
            );

         } catch (error) {
            message.error("Image compression failed");
            return Upload.LIST_IGNORE;
         }
      }

      const formData = new FormData();
      formData.append('file', command === 'update-question-image' ? uploadFile : file);

      let url = '';

      if (props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic')
         url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMasteryFile?s3path=${process.env.REACT_APP_S3_MASTERY_ASSESSMENT_QUESTIONAIRE_PATH}`;

      if (props.assessment_type === 'summative' || props.assessment_type === 'formative')
         url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMasteryFile?s3path=${process.env.REACT_APP_S3_ASSESSMENT_QUESTIONAIRE_PATH}`;


      axios.post(url, formData, upload_option).then(response => {
         console.log(response);

         if (response.data) {
            const data = response.data;

            handleRequest(command, data, props.id);

            if (command === 'update-question-image')
               setQuestionImage(`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${data.substring(data.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), data.length)}`);
               // Utils.getBase64(file, imageb64 =>
               //    setQuestionImage(imageb64),
               // );


            if (command === 'update-question-audio')
               setQuestionAudio(`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${data.substring(data.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), data.length)}`);
               // Utils.getBase64(file, audiob64 =>
               //    setQuestionAudio(audiob64),
               // );


            if (command === 'update-question-video')
               setQuestionVideo(`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${data.substring(data.indexOf(props.assessment_type === 'mastery' || props.assessment_type === 'diagnostic' ? 'mastery-assessment' : 'assessment'), data.length)}`);
               // Utils.getBase64(file, videob64 =>
               //    setQuestionVideo(videob64),
               // );

            // handleRequest("update-question-image", data, props.id);
            setIsUploading(false);
         }
      }, (error) => {
         console.log(error.message);
         setIsUploading(false);
      });
   };

   const renderQuestionSection = (template) => {
      const isViewMode =
         props.mode === "answer" ||
         props.mode.includes("assign") ||
         props.mode.includes("view");

      const renderWysiwyg = () => (
         <WysiwygMathEditor
            id={props.id}
            changeContentCallback={(e) => handleRequest("update-question", e, props.id)}
            content={editorContent}
            height={300}
            disabled={isViewMode}
         />
      );

      const renderUpload = (type, file, beforeUpload, accept, icon, player) => (
         <Dragger
            showUploadList={false}
            style={{
               backgroundColor: "#fff",
               borderRadius: "7px",
               padding: 0,
               border: "1px solid #ccc",
            }}
            beforeUpload={beforeUpload}
            maxCount={1}
            accept={accept}
            height="300px"
            disabled={isViewMode}
         >
            {file ? (
               (() => {
                  const previewNode =
                     type === "image" && React.isValidElement(player)
                        ? React.cloneElement(player, {
                           width: "100%",
                           height: "100%",
                           className: `${player.props?.className || ""} brainee-upload-image-preview`.trim(),
                           style: {
                              ...(player.props?.style || {}),
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              objectPosition: "center",
                              display: "block",
                           },
                        })
                        : player;

                  return (
               <div
                  style={{
                     display: "flex",
                     justifyContent: "center",
                     backgroundColor: "#FFF",
                     borderRadius: "7px",
                     height: "265px",
                     alignItems: "center",
                     overflow: "hidden"
               }}>
                  <div style={{ 
                     width: '100%', 
                     height: '100%',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center'
                  }}>
                     {previewNode}
                  </div>
               </div>
                  );
               })()
            ) : (
               <div style={{ padding: "20px" }}>
                  <p className="ant-upload-drag-icon">{icon}</p>
                  <p className="ant-upload-text">
                     Click or drag {type} file to this area to add
                  </p>
               </div>
            )}
         </Dragger>
      );

      const sectionStyle = { paddingBottom: 10, opacity: "90%" };

      const renderRow = (content, gutter = 6) => (
         <Row style={sectionStyle} gutter={gutter}>
            {content}
         </Row>
      );

      switch (String(template)) {
         case "1":
            return renderRow(
               <Col span={24}>
                  {isViewMode ? (
                     // Rendered as raw HTML so KaTeX markup (SVG viewBox, MathML,
                     // Unicode math symbols) is preserved exactly as the editor saved it.
                     <div
                        style={{
                           textOverflow: "ellipsis",
                           overflow: "auto",
                           backgroundColor: "#FFF",
                           maxHeight: "300px",
                           padding: "10px",
                           border: "1px solid lightgray",
                           borderRadius: "7px",
                        }}
                        dangerouslySetInnerHTML={{ __html: stripQuillFormulaGuards(editorContent) }}
                     />
                  ) : (
                     renderWysiwyg()
                  )}
               </Col>
            );

         case "2":
            return renderRow(
               <Col span={24}>
                  {renderUpload(
                     "image",
                     questionImage,
                     beforeImageUpload,
                     ".png,.jpg,.gif,.jpeg",
                     <PictureOutlined />,
                     <Image
                        src={questionImage}
                        preview={isViewMode}
                        // height={"100%"}
                        style={{ 
                           width: '100%', 
                           height: '100%', 
                           objectFit: 'scale-down', // This makes image fit properly
                           objectPosition: 'center'
                        }} 
                     />
                  )}
               </Col>
            );

         case "3":
            return renderRow(
               <>
                  <Col sm={24} md={12}>{renderWysiwyg()}</Col>
                  <Col sm={24} md={12}>
                     {renderUpload(
                        "image",
                        questionImage,
                        beforeImageUpload,
                        ".png,.jpg,.gif,.jpeg",
                        <PictureOutlined />,
                        <Image
                           src={questionImage}
                           preview={isViewMode}
                           // height="100%"
                           style={{ 
                              width: '100%', 
                              height: '100%', 
                              objectFit: 'scale-down', // This makes image fit properly
                              objectPosition: 'center'
                           }} 
                        />
                     )}
                  </Col>
               </>,
               [10, 10]
            );

         case "4":
            return renderRow(
               <Col span={24}>
                  {renderUpload(
                     "audio",
                     questionAudio,
                     beforeAudioUpload,
                     ".mp3,.wav",
                     <SoundOutlined />,
                     <ReactPlayer
                        controls
                        width="100%"
                        height="100%"
                        url={questionAudio}
                     />
                  )}
               </Col>
            );

         case "5":
            return renderRow(
               <>
                  <Col sm={24} md={12}>{renderWysiwyg()}</Col>
                  <Col sm={24} md={12}>
                     {renderUpload(
                        "audio",
                        questionAudio,
                        beforeAudioUpload,
                        ".mp3,.wav",
                        <SoundOutlined />,
                        <ReactPlayer
                           controls
                           width="100%"
                           height="100%"
                           url={questionAudio}
                        />
                     )}
                  </Col>
               </>,
               [10, 10]
            );

         case "6":
            return renderRow(
               <Col span={24}>
                  {renderUpload(
                     "video",
                     questionVideo,
                     beforeVideoUpload,
                     ".mp4,.webm,.ogv,.wmv",
                     <VideoCameraOutlined />,
                     <ReactPlayer
                        controls
                        width="100%"
                        height="100%"
                        url={questionVideo}
                     />
                  )}
               </Col>
            );

         case "7":
            return renderRow(
               <>
                  <Col sm={24} md={12}>{renderWysiwyg()}</Col>
                  <Col sm={24} md={12}>
                     {renderUpload(
                        "video",
                        questionVideo,
                        beforeVideoUpload,
                        ".mp4,.webm,.ogv,.wmv",
                        <VideoCameraOutlined />,
                        <ReactPlayer
                           controls
                           width="100%"
                           height="100%"
                           url={questionVideo}
                        />
                     )}
                  </Col>
               </>,
               [10, 10]
            );

         default:
            return null;
      }
   };

   const cardLabel = (card_type) => {
      const labels = {
         short_answer: 'Short Answer',
         long_answer: 'Open-ended/Essay',
         multiple_choice: 'Multiple Choice',
         multiple_choice_image: 'Multiple Choice',
         multiple_answer: 'Multiple Answer',
         multiple_answer_image: 'Multiple Answer',
         matching_type: 'Matching Type',
         matching_type_image: 'Matching Type',
         true_or_false: 'True or False'
      };

      return (
         <Text style={{ color: '#494949', fontWeight: 'bold' }}>
            {labels[card_type] || ''}
         </Text>
      );
   }

   const handleMenuClick = (e) => {
      props.templateReplaceCallback('replace', "", "", props.id, e.key);
   }

   const menu_question_template = (
      <Menu
         onClick={handleMenuClick}
         items={[
            {
               label: 'TEXT',
               key: '1',
               // icon: <CheckCircleOutlined />,
            },
            {
               label: 'IMAGE',
               key: '2',
               // icon: <CheckCircleOutlined />,
            },
            {
               label: 'TEXT & IMAGE',
               key: '3',
               // icon: <CheckCircleOutlined />,
            },
            {
               label: 'AUDIO',
               key: '4',
               // icon: <CheckCircleOutlined />,
            },
            {
               label: 'TEXT & AUDIO',
               key: '5',
               // icon: <CheckCircleOutlined />,
            },
            {
               label: 'VIDEO',
               key: '6',
               // icon: <CheckCircleOutlined />,
            },
            {
               label: 'TEXT & VIDEO',
               key: '7',
               // icon: <CheckCircleOutlined />,
            },
         ]}
      />
   );

   const generateQuestionCard = () => {
      const isAnswerMode = props.mode === "answer";
      const isAssignMode = props.mode.includes("assign");
      const isViewMode = props.mode.includes("view");
      const isReadOnly = isAnswerMode || isAssignMode || isViewMode;
      const canEdit = !isReadOnly;
      const isCreateOrEdit = props.mode === "create" || props.mode === "edit";
      const isSectionCard = props.type === "section" || props.type === "instruction";
      const cardWidth = isAnswerMode ? 600 : 800;

      const cardStyle = {
         marginBottom: 15,
         // marginRight: 20,
         // marginLeft: 15,
         minWidth: 400,
         maxWidth: cardWidth
      };

      const getResultPalette = () => {
         if (
            props.type === "section" ||
            props.type === "instruction" ||
            props.type === "long_answer" ||
            props.type === "matching_type" ||
            props.matched === undefined
         ) {
            return {
               backgroundColor: "#f6f9fd",
               borderColor: "rgba(3, 61, 137, 0.24)",
               accentColor: "rgba(3, 61, 137, 0.62)",
               ribbonColor: "#033D89",
               answerCardBackground: "#FFFFFF",
               shadowColor: "rgba(22, 64, 132, 0.08)"
            };
         }

         return props.matched
            ? {
               backgroundColor: "#F5FBF7",
               borderColor: "rgba(46, 125, 82, 0.24)",
               accentColor: "rgba(46, 125, 82, 0.56)",
               ribbonColor: "#2E7D52",
               answerCardBackground: "#FCFFFD",
               shadowColor: "rgba(46, 125, 82, 0.08)"
            }
            : {
               backgroundColor: "#FFF8F8",
               borderColor: "rgba(198, 40, 40, 0.24)",
               accentColor: "rgba(198, 40, 40, 0.56)",
               ribbonColor: "#C62828",
               answerCardBackground: "#FFFDFD",
               shadowColor: "rgba(198, 40, 40, 0.08)"
            };
      };

      const getBackgroundColor = () => {
         return getResultPalette().backgroundColor;
      };

      const getCardShadow = () => {
         const palette = getResultPalette();
         return `0 16px 34px ${palette.shadowColor}, inset 4px 0 0 ${palette.accentColor}`;
      };

      const renderRemoveButton = (title) => (
         <Popconfirm
            title={title}
            onConfirm={() =>
               handleCardRequest("remove", props.id)
            }
            okText="Yes"
            cancelText="No"
            placement="left"
         >
            <CloseCircleTwoTone
               twoToneColor="#aaa"
               style={{
                  cursor: "pointer",
                  fontSize: 24
               }}
            />
         </Popconfirm>
      );

      const renderSectionExtra = () => {
         if (!canEdit) return null;

         return (
            <Space>
               {renderRemoveButton("Remove this section?")}
            </Space>
         );
      };

      const renderQuestionExtra = () => {
         if (canEdit) {
            return (
               <Space>
                  {props.question_type === "2" && (
                     <Tooltip
                        placement="left"
                        title="Change Template"
                     >
                        <Dropdown
                           overlay={menu_question_template}
                           placement="bottomCenter"
                           trigger={["click"]}
                           arrow
                        >
                           <RetweetOutlined
                              style={{
                                 cursor: "pointer",
                                 fontSize: 24,
                                 color: "#aaa"
                              }}
                           />
                        </Dropdown>
                     </Tooltip>
                  )}

                  {renderRemoveButton(
                     "Remove this answer key?"
                  )}
               </Space>
            );
         }

         if (
            props.mode === "teacher-view" &&
            props.type === "short_answer" &&
            props.matched === false &&
            enable_consider
         ) {
            return (
               <Popconfirm
                  title="Are you sure you want to consider this answer?"
                  onConfirm={() =>
                     handleConsiderAnswer(
                        props.question_key_id,
                        props.answers
                     )
                  }
                  okText="Yes"
                  cancelText="No"
               >
                  <Button
                     size="small"
                     className="button-shadow"
                     type="primary"
                     shape="round"
                  >
                     Consider Answer
                  </Button>
               </Popconfirm>
            );
         }

         return null;
      };

      const renderQuestionTitle = () => (
         <Space size="small">
            <Tooltip
               placement="right"
               title={isCreateOrEdit ? "Click to duplicate this item" : null}
            >
               <Avatar
                  style={{
                     backgroundColor: "#033D89",
                     verticalAlign: "middle",
                     cursor: isCreateOrEdit
                        ? "pointer"
                        : "default"
                  }}
                  size="middle"
                  gap={2}
                  onClick={
                     isCreateOrEdit
                        ? () => handleCardRequest("duplicate", props.id)
                        : undefined
                  }
               >
                  {props.index}
               </Avatar>
            </Tooltip>

            {cardLabel(props.type)}

            {isCreateOrEdit &&
               !props.type.includes("matching_type") && (
                  <InputNumber
                     addonBefore="Points"
                     min={1}
                     max={100}
                     style={{ width: 130 }}
                     value={props.points}
                     onChange={(val) => handleRequest("update-points", val, props.id)}
                  />
               )}
         </Space>
      );

      const renderSectionContent = () => {
         if (isReadOnly) {
            return (
               // Rendered as raw HTML so KaTeX markup (SVG viewBox, MathML,
               // Unicode math symbols) is preserved exactly as the editor saved it.
               // Quill's embed guard characters - stored as a literal "?" by rows
               // written before the utf8mb4 migration - are stripped first.
               <div
                  style={{
                     textOverflow: "ellipsis",
                     overflow: "auto",
                     backgroundColor: "#FFF",
                     maxHeight: 300,
                     padding: 10,
                     borderRadius: 7
                  }}
                  dangerouslySetInnerHTML={{ __html: stripQuillFormulaGuards(editorContent) }}
               />
            );
         }

         return (
            <WysiwygMathEditor
               id={props.id}
               content={props.question}
               height={200}
               disabled={false}
               changeContentCallback={(e) => handleRequest("update-question", e, props.id)}
            />
         );
      };

      const renderAddAnswerButton = () => {
         if (props.type === "long_answer" || !canEdit) {
            return null;
         }

         if (props.type === "short_answer") {
            return (
               // <Button
               //    className="button-shadow"
               //    type="primary"
               //    shape="round"
               //    onClick={() => handleRequest("add-correct", "", -1)
               //    }
               // >
               //    <PlusOutlined />
               //    Add Correct Answer
               // </Button>
               <Button 
                  className='button-shadow' 
                  type='primary' 
                  shape='round' 
                  onClick={() => handleRequest("add-correct", "", -1)}>
                     <Text ellipsis style={{ color: "#fff" }}><PlusOutlined /> Add Correct Answer</Text>
               </Button>
            );
         }

         if (
            props.type.includes("matching_type")
         ) {
            return (
               <Button
                  className="button-shadow"
                  type="primary"
                  shape="round"
                  onClick={() => handleRequest("add-mt", "", -1)}
               >
                  <Text ellipsis style={{ color: "#fff" }}><PlusOutlined /> Add Answer Key</Text>
               </Button>
            );
         }

         if (
            !props.type.includes(
               "true_or_false"
            )
         ) {
            return (
               <Button
                  className="button-shadow"
                  type="primary"
                  shape="round"
                  onClick={() => handleRequest("add", "", -1)}
               >
                  <Text ellipsis style={{ color: "#fff" }}><PlusOutlined /> Add Answer Key</Text>
               </Button>
            );
         }

         return null;
      };

      if (isSectionCard) {
         return (
            <Card
               key={props.id}
               className="card-shadow"
               hoverable
               style={{
                  ...cardStyle,
                  backgroundColor: getBackgroundColor(),
                  border: `1px solid ${getResultPalette().borderColor}`,
                  boxShadow: getCardShadow()
               }}
               title={
                  <Text
                     type="secondary"
                     style={{
                        fontSize: 14,
                        fontWeight: "bold"
                     }}
                  >
                     {`${props.type.toUpperCase()} ${props.index}`}
                  </Text>
               }
               extra={renderSectionExtra()}
            >
               {renderSectionContent()}
            </Card>
         );
      }

      return (
         <Card
            key={props.id}
            className="card-shadow"
            hoverable
            title={renderQuestionTitle()}
            extra={renderQuestionExtra()}
            style={{
               ...cardStyle,
               backgroundImage: `url(../images/${props.card_bg})`,
               backgroundRepeat: "no-repeat",
               backgroundSize: "100% 100%",
               backgroundBlendMode: "soft-light",
               backgroundColor: getBackgroundColor(),
               border: `1px solid ${getResultPalette().borderColor}`,
               boxShadow: getCardShadow()
            }}
         >
            { props.question_type === "2" && renderQuestionSection(props.template) }

            { props.type !== "long_answer" &&
               props.question_type === "2" && (
                  <Divider orientation="center">
                     <Title level={5}>
                        {canEdit
                           ? "Answer Keys"
                           : props.mode.includes("teacher") || props.mode === "preview"
                              ? "Answer"
                              : "Your Answer"}
                     </Title>
                  </Divider>
            )}

            { generateQuestionOptions() }

            {/* 1TVET overlay: essay score + remarks, dropped by CC's component refactor.
                Restored verbatim from CC's own BraineeQuestionCard_Old.js:1441-1463. */}
            { props.type === "long_answer" &&
               (props.mode === "teacher-view" || props.mode === "student-view") && (
                  <Descriptions bordered size="small" column={4} style={{ marginTop: "10px" }}>
                     <Descriptions.Item label={"Points (Max: " + points + ")"} span={4} style={{ fontSize: 13 }}>
                        <InputNumber
                           id={"essayinput" + props.id}
                           disabled
                           size="middle"
                           style={{ width: "100%", borderRadius: "7px" }}
                           defaultValue={props.essay_score}
                        />
                     </Descriptions.Item>
                     <Descriptions.Item label="Comments/Remarks" span={4} style={{ fontSize: 13 }}>
                        <TextArea
                           disabled
                           id={"essaytext" + props.id}
                           name={"essaytext" + props.id}
                           rows={5}
                           defaultValue={props.essay_comment}
                        />
                     </Descriptions.Item>
                  </Descriptions>
               )}

            { (props.matched === false && props.type !== "long_answer") && (
               <Badge.Ribbon
                  text="Correct Answer"
                  color={getResultPalette().ribbonColor}
               >
                  <Card
                     size="small"
                     style={{
                        marginTop: 10,
                        textAlign: "left",
                        backgroundColor: getResultPalette().answerCardBackground,
                        border: `1px solid ${getResultPalette().borderColor}`
                     }}
                  >
                     {getCorrectAnswer(props.type, props.correct, props.option_labels)}
                  </Card>
               </Badge.Ribbon>
            )}

            { props.item_analysis_data && (
               <>
                  <Divider orientation="center">
                     <Title level={5}>
                        Students Answer
                        Distribution
                     </Title>
                  </Divider>

                  <Row
                     gutter={16}
                     onClick={() => handleShowStudentAnswers()}
                  >
                     <Col span={10}>
                        <Statistic
                           title="Total Students Answered"
                           value={GetTotalAnswered(
                              props.item_analysis_data
                                 .questionType,
                              props.item_analysis_data
                                 .correctCount,
                              props.item_analysis_data
                                 .wrongCount,
                              props.item_analysis_data
                                 .optionCounts
                           )}
                        />
                     </Col>

                     <Col span={14}>
                        {RenderAnalysisGraph(
                           props.item_analysis_data
                              .questionType,
                           props.item_analysis_data
                              .correctCount,
                           props.item_analysis_data
                              .wrongCount,
                           props.item_analysis_data
                              .optionCounts
                        )}
                     </Col>
                  </Row>
               </>
            )}

            { renderAddAnswerButton() && (
               <div
                  style={{
                     display: "flex",
                     justifyContent: "center",
                     marginTop: 10
                  }}
               >
                  {renderAddAnswerButton()}
               </div>
            )}
         </Card>
      );
   };

   const handleShowStudentAnswers = () => {setShowStudentAnswers(true);}

   function GetLabels(qt, cc, wc, oc) {
      var retVal = [];
      switch (qt) {
         case "multiple_choice": case "multiple_choice_image":
            var len = Object.keys(oc).length;
            retVal = alphabet.slice(0, len);

            for (let i = 0; i < len; i++) {
               retVal[i] = retVal[i] + ': ' + oc[i];
            }
            break;
         case "true_or_false":
            retVal = ["True: " + oc[0], "False: " + oc[1]];
            break;
         case "short_answer": case "multiple_answer": case "multiple_answer_image": case "matching_type": case "matching_type_image":
            retVal = ["Correct: " + cc, "Incorrect: " + wc];
            break;
         default:
            retVal = [];
      }

      return retVal;
   }

   function GetData(qt, cc, wc, oc) {
      var retVal = [];
      var oc_len = Object.keys(oc).length;

      switch (qt) {
         case "multiple_choice": case "multiple_choice_image":
            for (let i = 0; i < oc_len; i++) {
               retVal.push(oc[i]);
            }
            break;
         case "true_or_false":
            retVal.push(oc[0]);
            retVal.push(oc[1]);
            break;
         case "short_answer": case "multiple_answer": case "multiple_answer_image":
            retVal.push(cc);
            retVal.push(wc);
            break;
         default:
            retVal = [];
      }

      return retVal;
   }

   function GetTotalAnswered(qt, cc, wc, oc) {
      var retVal = 0;
      switch (qt) {
         case "multiple_choice": case "multiple_choice_image": case "true_or_false":
            retVal = Object.values(oc).reduce((total, value) => total + value, 0);
            break;
         case "short_answer": case "multiple_answer": case "multiple_answer_image": case "matching_type": case "matching_type_image":
            retVal = cc + wc;
            break;
         default:
            retVal = 0;
      }

      return retVal;
   }

   const RenderAnalysisGraph = (qt, cc, wc, oc) => {
      return (
         <Bar
            options={{
               responsive: true,
               scales: {
                  y:
                  {
                     min: 0,
                     max: ["short_answer", "multiple_answer", "multiple_answer_image"].includes(qt) ? cc + wc : Object.values(oc).reduce((total, value) => total + value, 0),
                     stepSize: 1,
                  },
                  x:
                     {},
               }
            }}
            data={{
               labels: GetLabels(qt, cc, wc, oc),
               datasets: [
                  {
                     label: "Student Count",
                     // Canvas (Chart.js) cannot resolve a CSS variable, so the bar colour is looked
                     // up in JS: #033D89 on CampusCloud, the 1TVET navy on a TVET campus.
                     backgroundColor: '#033D89',
                     borderColor: "#10292bff",
                     data: GetData(qt, cc, wc, oc),
                  },
               ],
            }}
         />
      )
   }

   return (
      <>
         {generateQuestionCard()}

         <Modal
            key="modal-upload"
            title={<div><Image src='../images/brainee_mascot.png' preview={false} height="30px" /> Upload File</div>}
            destroyOnClose={true}
            centered
            open={isUploading}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
         >
            <span>Uploading...</span>
            <Progress
               percent={percentage}
               status="active"
               strokeColor={{
                  '0%': '#5A98D2',
                  '100%': '#1b5596',
               }}
            />
         </Modal>

         <Modal
            key="modal-item-analysis"
            title={<div><Image src='../images/brainee_mascot.png' preview={false} height="30px" /> Student Answers</div>}
            destroyOnClose={true}
            centered
            open={showStudentAnswers}
            okButtonProps={{ shape: "round" }}
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            onOk={() => setShowStudentAnswers(false)}
            style={{ minWidth: "350px", maxWidth: "1150px" }}
            width={"90%"}
         >
            <ItemAnalysisAnswers
               id={props.id}
               assign_id={props.assign_id}
               assessment_type={props.assessment_type}
               correct_answer={props.item_analysis_data !== undefined ? props.item_analysis_data.correctAnswer : []}
               question_type={props.item_analysis_data !== undefined ? props.item_analysis_data.questionType : ""}
            />
         </Modal>
      </>
   )
}


